import React from "react";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import createStyles from "@material-ui/core/styles/createStyles";
import withStyles from "@material-ui/core/styles/withStyles";
import { Footer } from "../components";
import routes from "../constants/routes";
import { Typography, Card } from "@material-ui/core";
import TopBar from "../components/navigation/Header/TopBar";

const styles = (theme: Theme) =>
  createStyles({
    content: {
      alignItems: "center",
      display: "flex",
      flexGrow: 1,
      justifyContent: "center",
      marginBottom: theme.spacing(8),
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
      marginTop: theme.spacing(8),
      maxWidth: theme.breakpoints.width("md")
    },
    divider: {
      marginBottom: theme.spacing(2),
      marginTop: theme.spacing(4)
    },
    link: {
      color: theme.palette.primary.main,
      textDecoration: "none",
      "&:hover": {
        textDecoration: "underline"
      }
    },
    linkWrapper: {
      marginBottom: theme.spacing(2)
    },
    root: {
      alignItems: "center",
      display: "flex",
      flexDirection: "column"
    },
    subtitle: {
      marginBottom: theme.spacing(2)
    },
    termsList: {
      ...theme.typography.body2
    },
    termsWrapper: {
      padding: theme.spacing(4),
      paddingBottom: theme.spacing(8)
    },
    title: {
      marginBottom: theme.spacing(4)
    }
  });

type State = {};

type Props = {
  authenticated: boolean;
  classes?: any;
};

class TermsAndConditions extends React.Component<Props, State> {
  render() {
    const { authenticated, classes } = this.props;
    return (
      <div className={classes.root}>
        {!authenticated && <TopBar />}
        <div className={classes.content}>
          <Card className={classes.termsWrapper}>
            <Typography className={classes.title} color="primary" variant="h2">
              {routes.TERMS.label}
            </Typography>
            <section>
              <Typography>
                The use of this website is subject to the following terms of
                use:
              </Typography>
              <ul className={classes.termsList}>
                <li>
                  You agree not to share your username with any other
                  individual.
                </li>
                <li>
                  The content of the pages of this website is for your
                  information and use only. It is subject to change without
                  notice.
                </li>
                <li>
                  This website uses cookies to monitor browsing preferences.
                </li>
                <li>
                  Neither we nor any third parties provide any warranty or
                  guarantee as to the accuracy, timeliness, performance,
                  completeness or suitability of the information and materials
                  found or offered on this web site for any particular purpose.
                  You acknowledge that such information and materials may
                  contain inaccuracies or errors and we expressly exclude
                  liability for any such inaccuracies or errors to the fullest
                  extent permitted by law.
                </li>
                <li>
                  Your use of any information or materials on this web site is
                  entirely at your own risk, for which we shall not be liable.
                </li>
                <li>
                  This web site contains material which is owned by or licensed
                  to us. This material includes, but is not limited to, the
                  design, layout, look, appearance and graphics. Reproduction is
                  prohibited other than in accordance with the copyright notice,
                  which forms part of these terms and conditions
                </li>
                <li>
                  Unauthorised use of this web site may give rise to a claim for
                  damages and/or be a criminal offence
                </li>
                <li>
                  From time to time this web site may also include links to
                  other web sites. These links are provided for your convenience
                  to provide further information. They do not signify that we
                  endorse the web site(s). We have no responsibility for the
                  content of the linked web site(s).
                </li>
                <li>
                  Your use of this website and any dispute arising out of such
                  use of the website is subject to the laws of New Zealand.
                </li>
              </ul>
            </section>
          </Card>
        </div>
        {!authenticated && (
          <Footer
            links={[
              { url: routes.HOME.url, label: "Home" },
              { url: routes.SUPPORT.url, label: routes.SUPPORT.label }
            ]}
          />
        )}
      </div>
    );
  }
}

export default withStyles(styles)(TermsAndConditions);
